import { createContext } from 'react';

export type TypeCustomTagState = {
  etiqueta: string;
  etiquetalabel: string;
  etiquetaimage: string;
  etiquetacheckoutimage: string;
};

type TypeCustomTag = {
  customTag: TypeCustomTagState;
  setCustomTag: (customTag: TypeCustomTagState) => void;
};

export const CustomTagDefault: TypeCustomTag = {
  customTag: {
    etiqueta: '',
    etiquetalabel: '',
    etiquetaimage: '',
    etiquetacheckoutimage: '',
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCustomTag: () => {},
};

export const CustomTag = createContext(
  CustomTagDefault, // valor por defecto
);
